module.exports = __webpack_public_path__ + "static/img/360aq_img_1.71c0ac97.png";